// ============================================================
// usePlateWatch - a shown plate's record for the fuzzer (plan body-map G1)
// ============================================================
// Notes in diagnostics/plateLog when a plate of a combatant mounts and goes,
// the impact already there (history, never played) and every impact handed
// to it after; usePlateHits notes what it plays through PlateWatch, the
// record's key. A plate without a combatant (the attacker's own small map)
// is not watched.

import { createContext, useEffect, useId, useState } from 'react';
import type { Impact } from '../../engine/impacts';
import { notePlateGone, notePlateHeard, notePlateMounted } from '../../diagnostics/plateLog';

/** The watched plate's key, for usePlateHits to note its plays under; null when it is not watched. */
export const PlateWatch = createContext<string | null>(null);

export default function usePlateWatch(
  combatantId: string | null | undefined,
  impact: Impact | null | undefined,
): string | null {
  const key = useId();
  const [atMount] = useState(() => impact?.id ?? null);
  useEffect(() => {
    if (!combatantId) return undefined;
    notePlateMounted(key, combatantId, atMount);
    return () => notePlateGone(key);
  }, [key, combatantId, atMount]);
  useEffect(() => {
    if (combatantId && impact && impact.id !== atMount) notePlateHeard(key, impact.id);
  }, [key, combatantId, impact, atMount]);
  return combatantId ? key : null;
}
